export const GAME_TYPE_LEAGUE = 'league.classic'
export const GAME_TYPE_KO = 'ko.classic'
export const GAME_TYPE_GROUPPHASE_WITH_KO = 'groupphase_with_ko'
export const GAME_TYPE_KO_MIXED = 'ko.mixed'

export default {
  methods: {
    getGameTypeLabel(type) {
      return this.$t(`gameMode.${type}`);
    },
    getGameTypeIcon(type) {
      if (type == GAME_TYPE_LEAGUE) {
        return "mdi-format-list-bulleted-type";
      } else if (type == GAME_TYPE_KO) {
        return "mdi-boxing-glove";
      } else if (type == GAME_TYPE_GROUPPHASE_WITH_KO) {
        return "mdi-view-split-vertical" // "mdi-format-list-bulleted-type";
      } else if (type === GAME_TYPE_KO_MIXED) {
        return "mdi-boxing-glove";
      }
      return "mdi-help";
    },
  }
}
